<template>
  <div>
    <modal-cadu :close="close" :width="500" v-model="show">
      <div slot="all" class="pt-10 pb-4 px-10">
        <div slot="header">
          <div class="font-primaria headline font-weight-bold pb-4" style="color: #00995d;">
            VINCULAR NÍVEL COM SELO
          </div>
        </div>

        <div slot="body">
          <ValidationObserver ref="observer">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <validation-provider mode="eager" rules="required" v-slot="{ errors }">
                  <autocomplete-cadu
                    v-model="seloNivel.nome"
                    title="Nome Certificação/Selo"
                    :errorMessage="errors[0]"
                    :items="listaCertificadoSelo.map((el) => el.nome)"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    @index="indexCertificacaoSelo"
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <checkList-cadu
                  titulo="Níveis"
                  itemTextFiltro="nome"
                  :lengthSize="20"
                  :listaFiltro="listaNiveis"
                  :tasks="niveisSelecionados"
                  overflow
                />
              </v-col>
            </v-row>
          </ValidationObserver>
        </div>

        <div slot="footer" class="pt-6">
          <v-row align="center" justify="end">
            <v-col cols="auto">
              <button-cadu @click="saveSeloNivel"> SALVAR </button-cadu>
            </v-col>
          </v-row>
        </div>
      </div>
    </modal-cadu>

    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import Selo from '@/services/Selos/Selo'
import TabelaDominios from '@/services/Dominios/TabelaDominios'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: this.value,
      close: true,
      tokenBearer: localStorage.getItem('tokenBearer'),

      seloNivel: { id: null, nome: '', niveis: [] },

      listaCertificadoSelo: [],
      listaNiveis: [],
      niveisSelecionados: [],

      error: false,
      errObj: {}
    }
  },
  methods: {
    async getSelos() {
      const selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await selo.getTiposSelo().then((res) => (this.listaCertificadoSelo = res.data))
    },
    async getNiveis() {
      const tabelaDominios = new TabelaDominios(this.tokenBearer, this.$appConfig.config.API)

      await tabelaDominios.getTabelaDominios(this.args).then((res) => (this.listaNiveis = res.data))
    },
    async saveSeloNivel() {
      if (await this.$refs.observer.validate()) {
        const selo = new Selo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

        await selo
          .putSeloNivel(this.seloNivel)
          .then(() => this.$emit('success'))
          .catch((err) => {
            this.error = true
            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message
          })
      }
    },

    indexCertificacaoSelo(index) {
      if (index > -1 && index !== null) {
        this.seloNivel.id = this.listaCertificadoSelo[index].id

        this.niveisSelecionados = this.listaCertificadoSelo[index].niveis.map((it) => {
          return {
            id: this.listaNiveis.find((nivel) => nivel.nome == it).id,
            title: it
          }
        })
      }
    }
  },
  watch: {
    value() {
      this.show = this.value
    },
    show() {
      if (!this.show) {
        this.seloNivel = { id: null, nome: '', niveis: [] }
        this.niveisSelecionados = []
        this.$emit('input', this.show)
      } else {
        this.getSelos()
        this.getNiveis()
      }
    },

    niveisSelecionados(nivel) {
      this.seloNivel.niveis = nivel.map((it) => it.id)
    }
  },
  computed: {
    args() {
      const params = {
        status: 'TODOS',
        tipoDominio: 'TIPO_SELO_NIVEL',
        direcaoOrdenacao: 'asc'
      }

      return new URLSearchParams(params).toString()
    }
  }
}
</script>

<style lang="scss" scoped></style>
